module.exports = __webpack_public_path__ + "static/media/CentraleSansLight.806cd79a.woff";